import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Form, Button, Spinner, Alert } from 'react-bootstrap';
import axios from 'axios';
import logoColor from '../../assets/logo-color.svg';

const INBOUND_BASE = process.env.REACT_APP_INBOUND_API_BASE || 'http://localhost:8004';

const pageStyle = {
  background: 'linear-gradient(135deg, #1e293b 0%, #334155 50%, #1e293b 100%)',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const cardStyle = {
  width: 420,
  background: '#fff',
  borderRadius: 24,
  boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)',
  border: 'none',
  padding: '2.5rem',
};

const titleStyle = {
  fontFamily: "'Inter', sans-serif",
  fontWeight: 800,
  fontSize: '1.5rem',
  color: '#1e293b',
  marginBottom: '0.25rem',
};

const labelStyle = {
  fontFamily: "'Inter', sans-serif",
  fontWeight: 600,
  fontSize: '0.8125rem',
  color: '#475569',
};

const inputStyle = {
  borderRadius: 10,
  border: '1px solid #e2e8f0',
  padding: '0.625rem 1rem',
  fontSize: '0.9rem',
};

const btnStyle = {
  background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
  border: 'none',
  fontFamily: "'Inter', sans-serif",
  fontWeight: 600,
  fontSize: '0.9rem',
  borderRadius: 12,
  padding: '0.75rem',
  boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)',
};

export default function SetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${INBOUND_BASE}/api/staff/set-password`, { token, password });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to set password. The link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={pageStyle}>
        <div style={cardStyle}>
          <Alert variant="danger">Invalid link. No token provided.</Alert>
        </div>
      </div>
    );
  }

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <div className="text-center mb-4">
          <img src={logoColor} alt="TopCX" style={{ height: 48, marginBottom: 12 }} />
          <h3 style={titleStyle}>Set Your Password</h3>
          <p style={{ color: '#64748b', fontSize: '0.9rem', margin: 0 }}>
            Create a password to access your account
          </p>
        </div>

        {success ? (
          <div className="text-center">
            <Alert variant="success">
              Password set successfully! You can now sign in.
            </Alert>
            <Button
              href="/login"
              variant="primary"
              className="w-100 mt-2"
              style={btnStyle}
            >
              Go to Login
            </Button>
          </div>
        ) : (
          <>
            {error && (
              <Alert variant="danger" dismissible onClose={() => setError('')}>
                {error}
              </Alert>
            )}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label style={labelStyle}>New Password</Form.Label>
                <Form.Control
                  style={inputStyle}
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Minimum 8 characters"
                  required
                  minLength={8}
                  autoFocus
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label style={labelStyle}>Confirm Password</Form.Label>
                <Form.Control
                  style={inputStyle}
                  type="password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  placeholder="Re-enter your password"
                  required
                />
              </Form.Group>

              <Button type="submit" className="w-100" disabled={loading} style={btnStyle}>
                {loading ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Setting password...
                  </>
                ) : (
                  'Set Password'
                )}
              </Button>
            </Form>
          </>
        )}
      </div>
    </div>
  );
}
